module.exports = __webpack_public_path__ + "img/141-Blanc Veiné Stylo.jpg";